import { lazy } from 'react';

import type { RouteConfig } from '../../types';

const DashboardLayout = lazy(() => import('@/layouts/DashboardLayout'));
const StructureVersionsLayout = lazy(() => import('@/pages/structureVersions/layout'));
const StructureVersionsPage = lazy(() => import('@/pages/structureVersions'));
const CreateStructureVersionPage = lazy(() => import('@/pages/structureVersions/create'));
const StructureVersionDetailPage = lazy(() => import('@/pages/structureVersions/[versionId]'));
const StructureVersionDivisionsPage = lazy(() => import('@/pages/structureVersions/[versionId]/divisions'));
const StructureVersionDivisionViewPage = lazy(
  () => import('@/pages/structureVersions/[versionId]/divisions/[divisionId]/view')
);
const StructureVersionMarketsPage = lazy(() => import('@/pages/structureVersions/[versionId]/markets'));
const StructureVersionMarketViewPage = lazy(
  () => import('@/pages/structureVersions/[versionId]/markets/[marketId]/view')
);
const StructureVersionStatesPage = lazy(() => import('@/pages/structureVersions/[versionId]/states'));
const StructureVersionStateViewPage = lazy(
  () => import('@/pages/structureVersions/[versionId]/states/[stateCode]/view')
);
const StructureVersionProjectsPage = lazy(() => import('@/pages/structureVersions/[versionId]/projects'));

export const structureVersionRoutes: RouteConfig = {
  path: '/structureVersions',
  layout: DashboardLayout,
  children: [
    {
      path: '',
      layout: StructureVersionsLayout,
      children: [
        {
          path: '',
          element: StructureVersionsPage,
        },
        {
          path: '/create',
          element: CreateStructureVersionPage,
        },
        {
          path: '/:versionId',
          children: [
            {
              path: '',
              element: StructureVersionDetailPage,
            },
            {
              path: '/divisions',
              children: [
                {
                  path: '',
                  element: StructureVersionDivisionsPage,
                },
                {
                  path: '/:divisionId/view',
                  element: StructureVersionDivisionViewPage,
                },
              ],
            },
            {
              path: '/markets',
              children: [
                {
                  path: '',
                  element: StructureVersionMarketsPage,
                },
                {
                  path: '/:marketId/view',
                  element: StructureVersionMarketViewPage,
                },
              ],
            },
            {
              path: '/states',
              children: [
                {
                  path: '',
                  element: StructureVersionStatesPage,
                },
                {
                  path: '/:stateCode/view',
                  element: StructureVersionStateViewPage,
                },
              ],
            },
            {
              path: '/projects',
              element: StructureVersionProjectsPage,
            },
          ],
        },
      ],
    },
  ],
};
